let _ = require('lodash');

const PERMISSIONS = {
    client: ['account'],
    manager: ['manager'],
    unauthorized: []
};

module.exports = {
    updateUserRole ({ user }, state) {
        let role = user.isManager ? 'manager' : 'client';
        if (state.get(['user', 'role']) !== role) {
            state.set(['user', 'role'], role);
        }
    },

    addUserRole ({ user }, state, output) {
        let role = user.isManager ? 'manager' : 'client';
        let extendedUser = Object.assign({ role }, user);

        output({ extendedUser });
    },

    getUser ({ auth }, state, output, { locator, context }) {
        let api = locator.resolve('api');
        let requestArgs = {};
        if (!state.get(['bitrix', 'isBitrix'])) {
            requestArgs.token = _.get(auth, 'access_token');
        }
        let request = api.getCurrentUser(context, locator, requestArgs);
        let username = state.get(['login', 'form', 'username']);

        request
            .then((response) => {
                let code = _.get(response, 'status.code');
                let content = _.get(response, 'content');

                if (code === 200) {
                    output.allowed({
                        user: content
                    });
                    return;
                }

                if (code === 503) {
                    if (content === 'NameResolutionFailure') {
                        output.nameResolutionFailure();
                        return;
                    } else if (content === 'TrustFailure') {
                        output.trustFailure();
                        return;
                    }
                }

                if (output[code]) {
                    output[code]({ username });
                    return;
                }

                output.denied();
            })
            .catch(() => {
                output.denied();
            });
    },

    refreshToken (args, state, output, { locator, context }) {
        let refreshToken = context.cookie.get('refresh_token');

        let methodParams = {
            grant_type: 'refresh',
            client_id: 'hermes',
            refresh_token: refreshToken
        };

        let API = locator.resolve('api');
        let request = API.refreshToken(context, { methodParams });

        request.then((data) => {
            let code = _.get(data, 'status.code');
            let auth = _.get(data, 'content');

            if (code === 401) {
                output.accessDenied({ code });
                return;
            }

            if (code === 400) {
                output.invalidValidation({ code });
                return;
            }

            if (code !== 200) {
                output.error({ code });
                return;
            }

            output.success({ auth });
        })
        .catch((error) => output.error({ error }));
    },

    checkAccessCookie (args, state, output, { context }) {
        let token = context.cookie.get('access_token');

        if (token) {
            output.exist({ token });
            return;
        }

        output.notExist();
    },

    checkRefreshCookie (args, state, output, { context }) {
        let refreshToken = context.cookie.get('refresh_token');

        if (refreshToken) {
            output.exist({ refreshToken });
            return;
        }

        output.notExist();
    },

    checkPermissions (key) {
        return function checkPermissions (args, state, output) {
            let role = state.get(['user', 'role']);

            let isAllowed = _.includes(PERMISSIONS[role], key);

            if (isAllowed) {
                output.allowed();
                return;
            }

            output.denied();
        };
    },

    isUnauthorized (args, state, output) {
        let role = state.get(['user', 'role']);

        if (role === 'unauthorized') {
            output.yes();
        } else {
            output.no();
        }
    },

    isManager (args, state, output) {
        let role = state.get(['user', 'role']);

        if (role === 'manager') {
            output.true();
        } else {
            output.false();
        }
    },

    addUserToArgs (args, state, output) {
        let user = state.get(['account', 'orders', 'currentOrder', 'localChanges', 'selectedUser']);
        output({ user });
    },

    isUserChanged (args, state, output) {
        let user = state.get(['account', 'orders', 'currentOrder', 'localChanges', 'selectedUser']);
        if (user) {
            output.true();
        } else {
            output.false();
        }
    },

    isEmailAssociated ({ email }, state, output, { locator, context }) {
        let API = locator.resolve('api');
        let request = API.isEmailAssociated(context, locator, email);

        request.then((data) => {
            let code = _.get(data, 'status.code');

            if (code === 404) {
                output.no();
                return;
            }

            if (code !== 200) {
                output.error({ error: code });
                return;
            }

            output.yes();
        }).catch((error) => output.error({ error }));
    }
};



// WEBPACK FOOTER //
// ./actions/user.js